import React, { Component } from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { ConfirmationModal } from "../../template/ConfirmationModal";
import ProductService from "../../services/ProductService";
import tableRequest from "../../models/tableRequest.js";
import CategoryService from "../../services/CategoryService";
import MessageComponent from "../../template/Message";
import { confirmAlert } from "react-confirm-alert";
import { Calendar } from 'primereact/calendar';
import UploaderFileService from "../../services/UploaderFileService"
import "react-confirm-alert/src/react-confirm-alert.css";
import $ from "jquery";
import CompanyMasterService from "../../services/CompanyMasterService";
import { TabView, TabPanel } from 'primereact/tabview';
import ApiService from '../../services/apiService';
import Loaders from '../../template/Loaders';

export default class ProductMaster extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.ApiService = new ApiService();
    this.CompanyMasterService = new CompanyMasterService();
    this.ProductService = new ProductService();
    this.CategoryService = new CategoryService();
    this.tblResponse = new tableRequest();
    this.UploaderFileService = new UploaderFileService();
    let today = new Date();
    this.invalidDates = [today];
    this.state = {
      visible: false,
      visible1: false,
      prodDes: true,
      updateLoader: false,
      formIsValid: true,
      CompId: "",
      ProductId: "",
      ProductName: "",
      ProductCd: "",
      ProductDsrcptn: "",
      ProductImg: "",
      GTIN: "",
      PackOF: "",
      ProductUrl: "",
      GenuineAudio: "",
      ProductUOM: "",
      activeIndex: 0,
      ProductValue: "",
      CategoryId: null,
      IsActive: false,
      sortOrder: "",
      items: "",
      Product: "",
      ManufactureName: "",
      RegistrationNo: "",
      CautionarySymbol: "",
      AntidoteStatement: "",
      MarketedBy: "",
      ExpDate: '',
      CustomerCareDetails: "",
      WarrantyPeriodInMonth: "",
      formError: {
        ProductName: null,
        Product: null,
        ProductCd: null,
        ProductDsrcptn: null,
        CategoryId: null,
        ExpDate: null,
        ProductImg: null,
        GenuineAudio: null,
        ProductUOM: null,
        ProductValue: null,
        WarrantyPeriodInMonth: null,
        uploadImageLabel: null,
        uploadImagePamphlet: null,
        SapProductCd: null,
        CompanyId: null
      },
      uploadFilePath: "",
      uploadImagPath: "",
      uploadImagDescPath: "",
      uploadImagDescAntiPath: "",
      uploadAudioPath: "",
      uploadImageLabel: "",
      uploadImagePamphlet: "",
      SapProductCd: "",
      TechnicalName: "",
      confirm: false,
      formHeading: "Add Product",
      buttonLabel: "Submit",
      sales: [],
      companyDDL: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
      CategoryDDL: [],
      compDisabled: false,
      checkerror: true,
      CompanyId: null
    };

    this.brandTemplate = this.brandTemplate.bind(this);
    this.brandDescTemplate = this.brandDescTemplate.bind(this);
    this.brandDescAntiTemplate = this.brandDescAntiTemplate.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.actionTemplate1 = this.actionTemplate1.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitDescForm = this.submitDescForm.bind(this);
    this.deleteFunc = this.deleteFunc.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.setFilePath = this.setFilePath.bind(this);
    this.setImageDescPath = this.setImageDescPath.bind(this);
    this.setImageDescAntiPath = this.setImageDescAntiPath.bind(this);
    this.setLabel = this.setLabel.bind(this);
    this.setPamphlet = this.setPamphlet.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.hideFunc1 = this.hideFunc1.bind(this);
    this.setAudioPath = this.setAudioPath.bind(this);
    this.myUploader = this.myUploader.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.openDialog1 = this.openDialog1.bind(this);
    this.onSort = this.onSort.bind(this);
  }

  // ... (other methods remain the same until the submitForm method)

  submitForm(event) {
    debugger
    event.preventDefault();
    let isfrmvalid = true;
    
    // Validate required fields
    if (!this.state.PackOF || !this.state.CompanyId) {
      this.setState({
        formError: {
          ...this.state.formError,
          PackOF: !this.state.PackOF ? "Please enter quantity" : null,
          CompanyId: !this.state.CompanyId ? "Please select company" : null
        }
      });
      return;
    }

    if (isfrmvalid) {
      var formData = {
        ProductId: this.state.ProductId == "" ? 0 : parseInt(this.state.ProductId),
        ProductImg: this.state.uploadImagPath,
        PackOF: this.state.PackOF,
        ProductUrl: this.state.ProductUrl1,
        CompId: this.state.CompanyId ? this.state.CompanyId.CompId : null
      };
      
      // allData = formData;
      
      setTimeout(() => {
        this.ProductService.CreateUpdateProduct(formData).then((data) => {
          const resdata = data.data;
          if (resdata !== null && resdata.ResponseCode === "200") {
            this.refs.Messchild.showSuccess(resdata.ResponseMessage);
            this.setState({
              loading: true,
              visible: false,
              visible1: false,
            });
            this.formReset();
            this.GetProducts();
          } else if (resdata.ResponseCode === "400") {
            this.refs.Messchild.showWarn(resdata.ResponseMessage);
          } else {
            this.refs.Messchild.showError(resdata.ResponseMessage);
          }
        });
      }, 100);
    }
  }

  // Edit data - actionTemplate1 method
  actionTemplate1(rowData, column) {
    debugger
    const filterCatDDL = this.state.CategoryDDL.filter(x => x.value == rowData.CategoryId);
    const editAddMode = () => {
      this.setState({
        visible1: true,
        formHeading: "Edit",
        buttonLabel: "Update",
        ProductId: rowData.ProductId,
        PackOF: rowData.PackOF,
        ProductUrl1: rowData.ProductUrl,
        uploadImagPath: rowData.ProductImg,
      });
      
      // Set the company value if available
      if (rowData.CompId) {
        const CompanyObj = this.state.companyDDL.filter(
          (x) => x.CompId == rowData.CompId
        );
        if (CompanyObj.length > 0) {
          this.setState({
            CompanyId: CompanyObj[0],
          });
        }
      }
    };
    
    return (
      <span>
        <Button
          type="button"
          icon="pi pi-pencil"
          onClick={editAddMode}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
      </span>
    );
  }

  // ... (other methods remain the same until the render method)

  render() {
    let header = (
      <div style={{ textAlign: "right" }}>
        <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
        <InputText
          type="search"
          onInput={this.searchFilter}
          placeholder="Global Search"
          size="30"
        />
      </div>
    );
    
    return (
      <>
        <MessageComponent ref="Messchild" />
        <Loaders loader={this.state.updateLoader} />
        <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
        <div className="heading">
          <h1>Product Master</h1>
        </div>

        <DataTable
          responsive={true}
          header={header}
          style={{ width: '100%' }}
          scrollable globalFilter={this.state.globalFilter}
          emptyMessage={this.state.emptyMessage}
          value={this.state.sales}
          sortMode="multiple"
          paginator={true}
          rows={this.state.rows}
          rowsPerPageOptions={[5, 10, 20]}
          totalRecords={this.state.totalRecords}
          lazy={true}
          first={this.state.first}
          onPage={this.onPage}
          onSort={this.onSort}
          className="tblAuto"
        >
          <Column field="ProductCd" header="Product Code" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="ProductName" header="Product Name" headerStyle={{ width: '100px' }} sortable={true} />
          <Column
            field="ProductImg"
            headerStyle={{ width: "120px" }}
            header="Product Image"
            body={this.brandTemplate}
          />
          <Column field="ProductUOM" header="Product UOM" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="Plant" header="Plant" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="PackOF" header="Quantity" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="ProductUrl" header="Product Url" headerStyle={{ width: '450px' }} sortable={true} />
          <Column field="ProductDscrptn" header="Product Description" headerStyle={{ width: '200px' }} sortable={true} />
          <Column field="Status" header="Status" headerStyle={{ width: '100px' }} sortable={true} />
          <Column body={this.actionTemplate} headerStyle={{ width: '80px' }} header="Add Product Image" />
          <Column body={this.actionTemplate1} headerStyle={{ width: '80px' }} header="Action" />
        </DataTable>
        
        {/* Dialog for Add Product Image */}
        <Dialog
          header={this.state.formHeading}
          blockScroll={true}
          visible={this.state.visible}
          className="popup-modal"
          modal={true}
          onHide={this.hideFunc}>
          <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
            <TabPanel header="Add Image">
              <form onSubmit={this.submitForm} style={{ overflow: "hidden" }}>
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Upload Product:</label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <FileUpload
                      name="productfile"
                      url={process.env.REACT_APP_API_URL + "Upload/FileUpload"}
                      auto={true}
                      onUpload={this.setImagePath}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.uploadImagPath ? (
                      <div className="p-fileupload-row">
                        <div>
                          <img
                            alt="pro.jfif"
                            role="presentation"
                            src={this.state.uploadImagPath}
                            width="50"
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.formError.ProductImg !== null ? (
                      <div className="error">
                        {this.state.formError.ProductImg}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      {this.state.buttonLabel}
                    </button>
                  </div>
                </div>
                <div>
                  <label>
                    Note: Fields marked as (
                    <span style={{ color: "red" }}>*</span>) are required
                  </label>
                </div>
              </form>
            </TabPanel>
          </TabView>
        </Dialog>
        
        {/* Dialog for Edit */}
        <Dialog
          header={this.state.formHeading}
          blockScroll={true}
          visible={this.state.visible1}
          className="popup-modal"
          modal={true}
          onHide={this.hideFunc1}
          style={{ width: '50vw' }}>
          <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
            <TabPanel header="Edit">
              <form onSubmit={this.submitForm} style={{ overflow: "hidden" }}>
                <div className="row">
                  {/* PDF Upload Section */}
                  <div className="col-md-4 text-right">
                    <label>Upload PDF:</label>
                  </div>
                  <div className="col-md-8 mb-3">
                    <FileUpload
                      name="pdfFile"
                      url={process.env.REACT_APP_API_URL + "Upload/PdfUpload"}
                      auto={true}
                      onUpload={this.setFilePath}
                      onError={this.onErrorPdf}
                      accept="application/pdf"
                      maxFileSize={30000000}
                    />
                    {this.state.ProductUrl1 ? (
                      <div className="p-fileupload-row mt-2">
                        <embed
                          src={this.state.ProductUrl1}
                          type="application/pdf"
                          width="100%"
                          height="200px"
                        />
                      </div>
                    ) : null}
                    {this.state.formError.ProductUrl1 !== null ? (
                      <div className="error">
                        {this.state.formError.ProductUrl}
                      </div>
                    ) : null}
                  </div>
                  
                  {/* Quantity Field */}
                  <div className="col-md-4 text-right">
                    <label>Quantity<span style={{ color: "red" }}>*</span>:</label>
                  </div>
                  <div className="col-md-8 mb-3">
                    <InputText
                      type="text"
                      value={this.state.PackOF}
                      onChange={this.handleChange1}
                      className="form-control"
                      name="PackOF"
                    />
                    {this.state.formError.PackOF !== null ? (
                      <div className="error">
                        {this.state.formError.PackOF}
                      </div>
                    ) : null}
                  </div>
                  
                  {/* Company Dropdown */}
                  <div className="col-md-4 text-right">
                    <label>Company<span style={{ color: "red" }}>*</span>:</label>
                  </div>
                  <div className="col-md-8 mb-3">
                    <Dropdown 
                      optionLabel="CompanyName" 
                      onChange={e => this.setState({ CompanyId: e.value })}
                      value={this.state.CompanyId} 
                      className="form-control" 
                      placeholder="Select Company" 
                      name="CompanyId" 
                      options={this.state.companyDDL} 
                    />
                    {this.state.formError.CompanyId !== null ? (
                      <div className='error'>{this.state.formError.CompanyId}</div> 
                    ) : null}
                  </div>
                  
                  {/* Submit Button */}
                  <div className="col-md-12 text-center mt-3">
                    <button type="submit" className="btn btn-primary">
                      {this.state.buttonLabel}
                    </button>
                  </div>
                </div>
                
                <div className="mt-3">
                  <label>
                    Note: Fields marked as (
                    <span style={{ color: "red" }}>*</span>) are required
                  </label>
                </div>
              </form>
            </TabPanel>
          </TabView>
        </Dialog>
      </>
    );
  }
}